/** Public terms of service page (no auth). Linked from the OAuth consent screen. */
export function Terms() {
  return (
    <div className="container" style={{ maxWidth: 760, padding: "2rem 1rem" }}>
      <h1>Terms of Service</h1>
      <p className="muted">Last updated: October 2026</p>

      <p>
        By using Wrestling Meet Tracker ("the app"), you agree to these terms.
        If you don't agree, please don't use the app.
      </p>

      <h2>Using the app</h2>
      <ul>
        <li>You must provide accurate account information and keep it current.</li>
        <li>
          You're responsible for activity under your account and for content you
          post (meets, messages, carpool entries, notes).
        </li>
        <li>
          Don't post unlawful, harassing, or infringing content, and don't
          misuse other members' personal information shared within a team.
        </li>
      </ul>

      <h2>Meet &amp; event information</h2>
      <p>
        Discovered meets are gathered from publicly available sources and are
        provided "as is" for convenience. Dates, venues, and details may be
        inaccurate or change — always confirm with the official event/source
        before traveling. We are not affiliated with the organizations that run
        these events.
      </p>

      <h2>Carpools &amp; team coordination</h2>
      <p>
        Carpool offers/requests and team messages are coordination tools between
        parents. We don't vet, arrange, or take responsibility for rides,
        transportation, or any arrangements members make with one another.
      </p>

      <h2>Notifications</h2>
      <p>
        You may receive email or SMS notifications for invites, reminders, and
        cancellations. You can opt out of reminders in your profile; SMS replies
        of STOP will unsubscribe where applicable.
      </p>

      <h2>Third-party services</h2>
      <p>
        The app integrates with Google (sign-in, Calendar, Maps), AWS, and
        Twilio/SendGrid. Your use of those features is also subject to those
        providers' terms.
      </p>

      <h2>Disclaimer &amp; limitation of liability</h2>
      <p>
        The app is provided "as is" without warranties of any kind. To the
        maximum extent permitted by law, we are not liable for any indirect or
        consequential damages arising from use of the app or reliance on meet
        information.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms; continued use after changes means you accept
        them.
      </p>

      <h2>Contact</h2>
      <p>
        Questions? Email{" "}
        <a href="mailto:seamus.owens@gmail.com">seamus.owens@gmail.com</a>.
      </p>

      <p style={{ marginTop: "1.5rem" }}>
        <a href="/">← Back to app</a> · <a href="/privacy">Privacy Policy</a>
      </p>
    </div>
  );
}
